import Image from "next/image"
import React from "react"
import { Link as ScrollLink } from "react-scroll"

import { Links } from "config/links"

import { useTailwindBreakpoints } from "components/hooks/use-tailwind-breakpoints"

import { Box } from "components/shared/box"
import { Button } from "components/shared/landing/button"
import { Link } from "components/shared/link"
import { Text } from "components/shared/text"

import styles from "./top-section.module.scss"

export function TopSection({ scrollTo }: { scrollTo: string }) {
  const { xs } = useTailwindBreakpoints()
  return (
    <Box className="relative">
      <video
        poster="/images/pages/bot-3d/top-section/top-bg.jpg"
        autoPlay
        loop
        muted
        playsInline
        className="absolute top-0 left-0 h-full w-full block object-cover"
      >
        <source src="/bots-3d.mp4" type="video/mp4" />
      </video>
      <div
        style={{
          background:
            "linear-gradient(90deg, rgba(38, 0, 133, 0.5) 0%, rgba(69, 23, 164, 0.075) 91.2%), url(/images/pages/bot-3d/top-section/pattern.png)",
          backgroundBlendMode: "normal, multiply",
        }}
        className="z-1"
      >
        <Box className="mt-20 mb-16 lg:mb-36 px-4 md:px-8 max-w-[1200px] relative">
          <Box full className="mt-16 md:mt-22 2xl:mt-36">
            <Text
              weight="bold"
              className={`uppercase text-h2 leading-h2 md:text-[110px] md:leading-[110px] 2xl:text-[140px] 2xl:leading-[140px] text-transparent ${styles["text-bordered"]}`}
            >
              3D NFT DROP
            </Text>
            <Text
              weight="bold"
              className="uppercase text-h2 leading-h2 md:text-[110px] md:leading-[110px] 2xl:text-[140px] 2xl:leading-[140px]"
            >
              For
              <br />
              Classic Bots
              <br />
              Holders
            </Text>

            <Text className="mt-[24px] 2xl:mt-10 max-w-[460px]">
              All Classic Cryptobots holders will get the 3D version of their Bots
            </Text>

            <Box row={!xs} className="mt-[26px] 2xl:mt-10 gap-[18px] lg:gap-4 max-w-[520px] sm:max-w-auto">
              <Link href={Links.OPENSEA_WRAPP} target="_blank" highlightOnHover={false} className="flex-1">
                <Button>Become a holder</Button>
              </Link>
              <Link href={Links.DISCORD} className="flex cursor-pointer" target="_blank" highlightOnHover={false}>
                <Button className="uppercase" showBot type="secondary">
                  Join our community
                </Button>
              </Link>
            </Box>

            <ScrollLink className="flex cursor-pointer mt-10" to={scrollTo} duration={1000} smooth={true}>
              <Image
                src="/images/pages/index/top-section/scroll-bottom-animation.gif"
                alt="Scroll down icon"
                width={60}
                height={60}
                priority
              />
            </ScrollLink>
          </Box>
        </Box>
      </div>
    </Box>
  )
}
